import { useMutation, useQuery } from '@tanstack/react-query';
import {
  createBannerActivity,
  getBannerList,
} from '@/lib/api/common/banner.api';
import { shuffleBanners } from '@/lib/utils/banner-view';
import { CreateBannerActivityInput } from '@/shared/banner-activity';

export function useBanner(id: number) {
  return useQuery({
    queryKey: ['banner', 'list', id],
    queryFn: async () => {
      const response = await getBannerList(id);
      return {
        ...response,
        data: shuffleBanners(response.data ?? []),
      };
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
  });
}

export function useCreateBannerActivity() {
  return useMutation({
    mutationFn: (input: CreateBannerActivityInput) =>
      createBannerActivity(input),
  });
}

export function useClickBanner() {
  return useMutation({
    mutationFn: (bannerId: number) =>
      createBannerActivity({ bannerId, type: 'click' }),
  });
}

export function useViewBanner() {
  return useMutation({
    mutationFn: (bannerId: number) =>
      createBannerActivity({ bannerId, type: 'impression' }),
  });
}